import { Platform, StatusBar, StyleSheet } from 'react-native';

import { COLOR } from 'utils/colors';
import {
    androidScreenMarginBottom,
    heightPercentageToDP,
    isPhone,
    isTablet,
    isTabletOrWeb,
    widthPercentageToDP,
} from 'utils/responsiveness';

const MOBILE_TOP_PADDING = StatusBar.currentHeight || 20;

const styles = StyleSheet.create({
    container: { flex: 1 },
    contentContainer: {
        flexGrow: 1,
        justifyContent: 'center',
    },
    keyboardAwareContainer: {
        flexGrow: 1,
        justifyContent: 'center',
    },
    dialog: {
        paddingTop: Platform.select({
            web: 0,
            default: isTablet
                ? 0
                : heightPercentageToDP(MOBILE_TOP_PADDING + 44),
        }),
        paddingHorizontal: 16,
        marginBottom: androidScreenMarginBottom,
    },
    button: { minWidth: isTabletOrWeb ? 120 : widthPercentageToDP(328) },
    closeButton: {
        position: 'absolute',
        top: Platform.select({
            web: 0,
            default: isTablet ? 20 : MOBILE_TOP_PADDING + 10,
        }),
        right: isPhone ? widthPercentageToDP(16) : 24,
        width: 40,
        height: 40,
    },
    closeSvg: {
        width: 16,
        height: 16,
    },
    description: {
        maxWidth: 724,
        marginTop: 8,
    },
    buttonText: {
        color: COLOR.BLACK,
    },
});

export default styles;
